import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Chip } from '@shared/ui-components/chip/chip';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { DropdownMenu } from '../../../../../../components/dropdown-menu/dropdown-menu';
import { ScrollableContainer } from '../../../../../../components/scrollable-container/scrollable-container';
import { type useCarouselMagazineIssueFilter } from '../../hooks/use-carousel-magazine-issue-filter';
import styles from './magazine-issue-filter-controls.module.scss';
export const MagazineIssueFilterControls = t0 => {
  const $ = _c(13);
  const {
    filterState,
    triggerLabel
  } = t0;
  const {
    currentMagazineIssueFilter,
    magazineIssueFilterDisplayedItems,
    magazineIssueFilterDropdownItems,
    setCurrentMagazineIssueFilter
  } = filterState;
  let t1;
  if ($[0] !== magazineIssueFilterDisplayedItems || $[1] !== setCurrentMagazineIssueFilter) {
    t1 = magazineIssueFilterDisplayedItems && magazineIssueFilterDisplayedItems.length > 1 && <ul className={styles["filter__item-list"]}>{magazineIssueFilterDisplayedItems.map(magazineIssueFilterItem => <li key={JSON.stringify(magazineIssueFilterItem.value)}><Chip aria-current={magazineIssueFilterItem.selected} aria-label={magazineIssueFilterItem.ariaLabel} className={styles.filter__item} label={magazineIssueFilterItem.label ?? ""} onClick={() => setCurrentMagazineIssueFilter?.(magazineIssueFilterItem.value)} theme={magazineIssueFilterItem.selected ? ChipTheme.Active : ChipTheme.Light} /></li>)}</ul>;
    $[0] = magazineIssueFilterDisplayedItems;
    $[1] = setCurrentMagazineIssueFilter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const magazineIssueChips = t1;
  let t2;
  if ($[3] !== currentMagazineIssueFilter || $[4] !== magazineIssueFilterDropdownItems || $[5] !== setCurrentMagazineIssueFilter || $[6] !== triggerLabel) {
    t2 = magazineIssueFilterDropdownItems && magazineIssueFilterDropdownItems.length > 1 && <DropdownMenu items={magazineIssueFilterDropdownItems.map(magazineIssueFilterItem_0 => ({
      "aria-label": magazineIssueFilterItem_0.ariaLabel,
      children: <>{magazineIssueFilterItem_0.label}</>,
      id: JSON.stringify(magazineIssueFilterItem_0.value),
      onAction: () => setCurrentMagazineIssueFilter?.(magazineIssueFilterItem_0.value),
      selected: magazineIssueFilterItem_0.selected
    }))} menuProps={{
      selectedKeys: currentMagazineIssueFilter ? [JSON.stringify(currentMagazineIssueFilter)] : [],
      selectionMode: "single"
    }} selected={magazineIssueFilterDropdownItems.some(_temp)} shouldMenuFlip={true} triggerLabel={triggerLabel} />;
    $[3] = currentMagazineIssueFilter;
    $[4] = magazineIssueFilterDropdownItems;
    $[5] = setCurrentMagazineIssueFilter;
    $[6] = triggerLabel;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const moreOptionsDropdown = t2;
  let t3;
  if ($[8] !== magazineIssueChips || $[9] !== moreOptionsDropdown) {
    t3 = (magazineIssueChips || moreOptionsDropdown) && <ScrollableContainer className={classNames(styles.filter)}>{magazineIssueChips}{moreOptionsDropdown}</ScrollableContainer>;
    $[8] = magazineIssueChips;
    $[9] = moreOptionsDropdown;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <>{t3}</>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
function _temp(dropdownItem) {
  return dropdownItem.selected;
}